import { useEffect, useRef } from 'react';
import { useEventTracking } from 'hooks/useEventTracking';
import { useCartContext } from 'context/CartContext/CartContext';
import { useAuthCode } from 'context/AuthCodeContext/AuthCodeContext';

export const useCheckoutTracking = () => {
  const { eventTracking } = useEventTracking();
  const { tickets, eventId } = useCartContext();
  const { authCode } = useAuthCode();
  const hasTrackedCheckout = useRef(false);

  useEffect(() => {
    eventTracking.page.viewed({
      pageName: 'checkout_page',
      url: window.location.href,
    });
  }, [eventTracking]);

  useEffect(() => {
    if (tickets.length > 0 && eventId && !hasTrackedCheckout.current) {
      const subtotal = tickets.reduce((acc, ticket) => acc + ticket.price, 0);
      hasTrackedCheckout.current = true;
      eventTracking.checkout.started({
        eventId: eventId,
        totalPrice: subtotal,
        paymentMethod: authCode ? 'MINI_PROGRAM' : 'QI_SERVICES_PAYMENT_GATEWAY',
      });
    }
  }, [tickets, eventId, eventTracking, authCode]);
};
